'use client';

import type { ReactNode } from 'react';

import { useRouter } from 'next/navigation';

/**
 * Opens the core cookie preferences the same way the core cookie button does: the event first,
 * the `?occ=true` query as the fallback for older consent components.
 */
export function CookieSettingsLink({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  const router = useRouter();

  const open = () => {
    const detail = { handled: false };
    window.dispatchEvent(new CustomEvent('eliadmin:open-cookie-preferences', { detail }));
    if (detail.handled) return;

    const params = new URLSearchParams(window.location.search);
    params.set('occ', 'true');
    router.push(`${window.location.pathname}?${params.toString()}`);
  };

  return (
    <button type="button" onClick={open} className={className}>
      {children}
    </button>
  );
}
